import EditIcon from '@mui/icons-material/Edit'
import ListIcon from '@mui/icons-material/List'
import {Stack, Typography, Button, Box} from '@mui/material'
import {useTranslation} from 'react-i18next'

import AnnouncementImageSrc from '../assets/Announcement.svg'
import {DowntimeAnalyticsEventName, FEATURE_NAMESPACE} from '../consts'
import {useTrackDowntimeDashboardAnalytics} from '../hooks'
import {useDowntimePlantId} from '../providers'

type NewStoppagesBannerProps = {
  newStoppagesCount: number
  setView: (view: 'list' | 'navigator' | null) => void
}

export const NewStoppagesBanner = ({newStoppagesCount, setView}: NewStoppagesBannerProps) => {
  const plantId = useDowntimePlantId()
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const trackDowntimeDashboardAnalytics = useTrackDowntimeDashboardAnalytics(plantId)

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }}
    >
      <Stack alignItems="center" spacing={3}>
        <Box
          component="img"
          src={AnnouncementImageSrc}
          sx={{textAlign: 'center', maxWidth: 240, width: '100%'}}
          alt={t('newStoppagesBanner.announcementImageAlt')}
        />
        <Typography variant="h3" data-test-id="new-stoppages-primary-message">
          {t('newStoppagesBanner.label.newStoppagesCount', {
            count: newStoppagesCount
          })}
        </Typography>
        <Typography variant="body1">{t('newStoppagesBanner.description')}</Typography>
        <Stack direction="row" justifyContent="center" spacing={2} useFlexGap flexWrap="wrap">
          <Button
            data-test-id={'view-as-list-button'}
            onClick={() => {
              trackDowntimeDashboardAnalytics({
                name: DowntimeAnalyticsEventName.UserOpenStoppagesToAmendList
              })
              setView('list')
            }}
            startIcon={<ListIcon />}
          >
            {t('newStoppagesBanner.actions.viewAsList')}
          </Button>
          <Button
            variant="contained"
            data-test-id={'amend-stoppages-button'}
            onClick={() => setView('navigator')}
            startIcon={<EditIcon />}
          >
            {t('newStoppagesBanner.actions.amendStoppages')}
          </Button>
        </Stack>
      </Stack>
    </Box>
  )
}
